import { render } from "./ProfilBubbleWindow.vue?vue&type=template&id=385fd93e&scoped=true"
import script from "./ProfilBubbleWindow.vue?vue&type=script&lang=js"
export * from "./ProfilBubbleWindow.vue?vue&type=script&lang=js"

import "./ProfilBubbleWindow.vue?vue&type=style&index=0&id=385fd93e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-385fd93e"

export default script